var chunkMapping = {
	"21": [
		38021
	],
	"88": [
		99326
	],
	"192": [
		27192
	],
	"294": [
		47913
	],
	"558": [
		52558
	],
	"563": [
		10563
	],
	"627": [
		64627
	],
	"681": [
		10304
	],
	"965": [
		93965
	],
	"998": [
		51998
	]
};
var idToExternalAndNameMapping = {
	"10304": [
		"default",
		"./App",
		68735
	],
	"10563": [
		"default",
		"./CopilotPOC",
		32547
	],
	"27192": [
		"default",
		"./Hub",
		51503
	],
	"38021": [
		"default",
		"./Usage",
		92655
	],
	"47913": [
		"default",
		"./Plan",
		92655
	],
	"51998": [
		"default",
		"./App",
		88759
	],
	"52558": [
		"default",
		"./ConnectorBuilder",
		83755
	],
	"64627": [
		"default",
		"./SelfService",
		92655
	],
	"93965": [
		"default",
		"./App",
		73361
	],
	"99326": [
		"default",
		"./McpMonitorView",
		51503
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}